import { ApiError } from "../../types/ApiError";
import Axios from "axios";

type ForgetPasswordCredentialsDTO = {
    email: string;
};
export const forgetpassword = (data: ForgetPasswordCredentialsDTO): Promise<ApiError> => {
    return Axios.post(
        `${import.meta.env.VITE_AAA_API_URL}student/forgotPassword`,
        data
    );
};